import React from "react";
import { Option, None } from "@swiggy-private/js-fp";

export interface ApiContextValue {
    host: Option<string>;
}

export const ApiContext = React.createContext<ApiContextValue>({ host: None });

if (__DEV__) {
    ApiContext.displayName = "ApiContext";
}
